import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import esTranslations from './locales/es.json';
import enTranslations from './locales/en.json';

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
] as const;

export type LanguageCode = typeof languages[number]['code'];

// Check localStorage first, then default to Spanish (Spain ad campaign)
const getInitialLanguage = (): string => {
  if (typeof localStorage !== 'undefined') {
    try {
      const stored = localStorage.getItem('i18nextLng');
      if (stored && ['en', 'es'].includes(stored)) {
        return stored;
      }
      const geoDetected = sessionStorage.getItem('i18n_geo_detected');
      if (geoDetected && ['en', 'es'].includes(geoDetected)) {
        return geoDetected;
      }
    } catch (e) {
      // localStorage not available
    }
  }
  return 'es';
};

const initialLanguage = getInitialLanguage();

const resources: Resource = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
};

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'en',
  supportedLngs: ['en', 'es'],
  ns: ['translation'],
  defaultNS: 'translation',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  returnEmptyString: false,
  returnNull: false,
  returnObjects: true,
  keySeparator: '.',
  initImmediate: false,
  load: 'languageOnly',
});

// On language change: persist preference
i18n.on('languageChanged', (lng) => {
  if (typeof localStorage !== 'undefined') {
    try { localStorage.setItem('i18nextLng', lng); } catch (e) {}
  }
});

export const getTranslation = (key: string, fallback: string): string => {
  const result = i18n.t(key);
  if (result === key) return fallback;
  return result;
};

export default i18n;
